import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { CustomAlert, CustomButton, Text } from '../../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../../shared/Helpers/functions';
import { Trash } from '../../../../../../shared/Assets/svgIcons';
import { ButtonWrapper } from '../../../../../../components/StyledComponents';

import { DispatchProperties, useSelector } from '../../../../../../redux/store';
import { deleteTarget, getTargets } from '../../../../../../redux/State/clientSlice/programTargetSlice';

const Delete = ({ id, programId, mobileButton }: { id: string; mobileButton?: boolean; programId: string }) => {
	const [openDelete, setOpenDelete] = useState<boolean>(false);
	const dispatch = useDispatch<DispatchProperties>();
	const isDeleting = useSelector((state) => state.programTarget.isDeleting);
	const includeMastered = useSelector((state) => state.programTarget.includeMastered);

	const deleteTargetHandler = () => {
		if (!id || !programId) return;

		dispatch(deleteTarget({ id, programId }))
			.then(unwrapResult)
			.then(() => {
				dispatch(getTargets({ programId, includeMastered }));
				setOpenDelete(false);
				toast('Deleted');
			})
			.catch(errorNormalizer);
	};

	return (
		<>
			{mobileButton ? (
				<div
					className="targetActionButton"
					onClick={(e) => {
						e.stopPropagation();
						setOpenDelete(true);
					}}
				>
					<Trash />
				</div>
			) : (
				<div className="actionRow" onClick={() => setOpenDelete(true)}>
					<div className="actionIcon">
						<Trash />
					</div>
					<div className="actionContent">
						<Text title="Remove" type="psm" fontWeight="medium" />
					</div>
				</div>
			)}
			<CustomAlert
				isBusy={isDeleting}
				title="Are you sure you want to delete selected target?"
				onClose={() => setOpenDelete(false)}
				open={openDelete}
				Content={() => (
					<ButtonWrapper>
						<CustomButton title="Delete target" onClick={deleteTargetHandler} disabled={isDeleting} />
						<CustomButton title="Cancel" buttonType="secondaryGray" onClick={() => setOpenDelete(false)} />
					</ButtonWrapper>
				)}
			/>
		</>
	);
};

export default Delete;
